export class EnumApiRegionorg {
    constructor() {
        /**
         * @dec 获取省份
         * @method get
         */
        this.regionorg_get_provinces = {
            url: '/api/gateway/pcsd-bp-regionorg/v1/provinces',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec 获取城市
         * @method get
         */
        this.regionorg_get_citys = {
            url: '/api/gateway/pcsd-bp-regionorg/v1/provinces/{provincecode}/cities',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec 获取区县、街道
         * @method get
         */
        this.regionorg_get_district = {
            url: '/api/gateway/pcsd-bp-regionorg/v1/provinces/{provincecode}/cities/{citycode}/districts',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
    }
}
